export default "<canvas id=\"unitsDoughnutChart\" style=\"width: 100%;\"></canvas>";